import React from 'react'

class Filter extends React.Component {

  handleCheck() {
    this.props.filterItems(this.props.filterBy.stateName, !this.props.filterBy.state);
  }

  spanClass() {
    if (this.props.filterBy.state) {
      return 'checked';
    } else {
      return 'unchecked';
    }
  }

  renderColorIndex() {
    if (this.props.filterBy.index_color){
      return (
        <span 
          className='filter-index' 
          style={{backgroundColor: this.props.filterBy.index_color}}
        />
      )
    }
  }

  render() {
    return ( 
      <div className='filter'>
        <span className='square-checkbox'>
          <input className='filter-check' id={`${this.props.type}-${this.props.filterBy.id}`} type='checkbox' checked={this.props.filterBy.state} onChange={() => {}} data-check={this.props.filterBy.text}/>
          <label htmlFor={`${this.props.type}-${this.props.filterBy.id}`} onClick={this.handleCheck.bind(this)}/>
        </span>
        <span className={`filter-name ${this.spanClass()}`}>
          {this.props.filterBy.text}
        </span>
        {this.renderColorIndex()}
      </div>
    );
  }
}

export default Filter
